import React from 'react';

const ComparisonTable = () => {
  return (
    <section className="py-20 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-4 overflow-x-auto">
        <h2 className="text-4xl font-black uppercase tracking-tighter mb-10 border-l-4 border-orange-600 pl-4">
          Hardshell Matrix
        </h2>
        
        <table className="w-full text-left border-collapse min-w-[800px]">
          <thead>
            <tr className="bg-zinc-900 border-b-2 border-orange-600 uppercase tracking-widest text-sm text-zinc-400">
              <th className="p-4 font-bold">Model</th>
              <th className="p-4 font-bold">Use Case</th>
              <th className="p-4 font-bold">Waterproof Rating</th>
              <th className="p-4 font-bold">Weight</th>
              <th className="p-4 font-bold">Price</th>
            </tr>
          </thead>
          <tbody className="text-zinc-200 font-medium">
            <tr className="border-b border-zinc-800 hover:bg-zinc-900/50 transition-colors">
              <td className="p-4 font-black uppercase text-orange-500">Apex Pro</td>
              <td className="p-4">Severe Alpine</td>
              <td className="p-4">28,000mm</td>
              <td className="p-4">410g</td>
              <td className="p-4 font-bold">$499</td>
            </tr>
            <tr className="border-b border-zinc-800 hover:bg-zinc-900/50 transition-colors bg-zinc-900/20">
              <td className="p-4 font-black uppercase">Ridge LT</td>
              <td className="p-4">Fast & Light</td>
              <td className="p-4">20,000mm</td>
              <td className="p-4">280g</td>
              <td className="p-4 font-bold">$349</td>
            </tr>
            <tr className="border-b border-zinc-800 hover:bg-zinc-900/50 transition-colors">
              <td className="p-4 font-black uppercase">Trekker</td>
              <td className="p-4">Backpacking</td>
              <td className="p-4">15,000mm</td>
              <td className="p-4">450g</td>
              <td className="p-4 font-bold">$229</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default ComparisonTable;